// Using a more reliable placeholder service
export const DEFAULT_PRODUCT_IMAGE = 'https://placehold.co/400x400/png?text=No+Image';

// Alternative options if needed:
// export const DEFAULT_PRODUCT_IMAGE = 'https://dummyimage.com/400x400/e0e0e0/ffffff&text=No+Image';
// export const DEFAULT_PRODUCT_IMAGE = 'https://picsum.photos/400/400';

export const getImageUrl = (path) => {
  if (!path) return DEFAULT_PRODUCT_IMAGE;
  if (path.startsWith('http') || path.startsWith('data:')) return path;
  if (path.startsWith('blob:')) return path;
  
  // Add cache-busting parameter to prevent caching issues with transparent PNGs
  const cacheBuster = `v=${Date.now()}`;
  return path.includes('?') ? `${path}&${cacheBuster}` : `${path}?${cacheBuster}`;
};

export const getProductImage = (product) => {
  if (product?.images?.length > 0 && product.images[0].url) {
    return getImageUrl(product.images[0].url);
  }
  return DEFAULT_PRODUCT_IMAGE;
};







